var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    [
      _vm.getComponents.isSelfCertnComm === true
        ? _c("self-certn-comm", {
            attrs: {
              bizDscd: this.bizDscd,
              successFnc: this.successFnc,
              failFnc: this.failFnc,
              beforeRouterName: this.beforeRouterName
            }
          })
        : _vm._e(),
      _vm.getComponents.isSmsEmailCertn === true
        ? _c("sms-email-certn", {
            attrs: {
              bizDscd: this.bizDscd,
              successFnc: this.successFnc,
              failFnc: this.failFnc,
              beforeRouterName: this.beforeRouterName
            }
          })
        : _vm._e(),
      _vm.getComponents.isSmsFrstCertn === true
        ? _c("sms-frst-certn", {
            attrs: {
              bizDscd: this.bizDscd,
              successFnc: this.successFnc,
              failFnc: this.failFnc,
              beforeRouterName: this.beforeRouterName
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }